module.exports = __webpack_public_path__ + "img/oddnary-variation-5.89509c54.jpg";